<!-- <%@ Page Language="C#" AutoEventWireup="true" Inherits="ClearView.Web.ClearViewAngularPage" %> -->
<!-- cxone modal-->
<div *ngIf="isCXOne" class="cx-one-ui">
    <div class="modal-header cxone-modal-header">
        <div class="cxone-modal-title" runat="server" Lang_Section="Recordings" Lang_Key="Contact_ID">Contact ID: {{ id }}</div>
        <div class="modal-close">
            <button type="button" class="icon-btn fill-iconDefault" (click)="close()">
                <svg class="icon-12">
                    <use href="../../App_Themes/CXone/icons/close.svg#close"></use>
                </svg>
            </button>
        </div>     
    </div>
        <div class="modal-body cxone-modal-body">
            <div class="details-header">
                <div class='agent-container'>
                    <div class="agent">
                        <span class="section-header" runat="server" Lang_Section="Roles" Lang_Key="Agent">Agent: </span>
                        <span *ngIf="agent" class="agent-name">{{agent}}</span>
                        <span *ngIf="!agent" class="agent-name" runat="server" Lang_Section="Contact_List" Lang_Key="Unassigned">Unassigned</span>
                    </div>
                    <div class="skill">
                        <span class="section-header">Skill: </span>
                        <span class="skill-name">{{ skill }}</span>
                    </div>
                </div><!--agent-container-->
                <div *ngIf="data?.CurrentStateName != null" class='details-container'>
                    <div class="state-container">
                        <div class="time-header"><span>{{data?.CurrentStateName}}</span></div>
                        <div class="time-box"><span class="time-text">{{data?.StateTimeDisplay}}</span></div>
                    </div>
                    <div class="state-container">
                        <div class="time-header"><span>Total</span></div>
                        <div class="time-box"><span class="time-text">{{data?.TotalTimeDisplay}}</span></div>
                    </div>
                </div><!--details-container-->
            </div><!--details-header-->
            <div class="table-container">
                <ag-grid-angular 
                    #contactListDetailsGrid
                    *ngIf="gridOptions != null"
                    class="ag-theme-balham flex-fill"
                    [gridOptions]="gridOptions">
                </ag-grid-angular>
            </div>
        </div>
    <div class="modal-footer cxone-modal-footer"></div>
</div>

<!-- default modal -->
<div *ngIf="!isCXOne" style="min-height: 300px; max-height: 550px;color: black;" class="d-flex flex-column">
    <div class="modal-header">
        <div style="font-size: 16px;color: black; ">{{ skill }}</div>
        <div class="modal-close">
            <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail" (click)="close()">
                <svg class="icon-16">
                    <use href="../../App_Themes/clearview-default/icons/utility/close.svg#close"></use>
                </svg>
            </button>
        </div>           
    </div>
    <div class="h-100 mh-100">
            <div class="modal-body d-flex flex-column h-100">
                <div class="d-flex flex-column h-100 pb-3">
                    <div style="margin: 8px;" class='d-inline-flex pl-2 pr-2 flex-column'>
                        <span class="mr-3"><span runat="server" Lang_Section="Recordings" Lang_Key="Contact_ID">Contact ID</span>:</span>
                        <span class="font-weight-bold mt-1">{{id}}</span>
                    </div>
                    <div style="margin: 8px;" class='d-inline-flex pl-2 pr-2 flex-column'>
                        <span class="mr-3"><span runat="server" Lang_Section="Roles" Lang_Key="Agent">Agent</span>:</span>
                        <span *ngIf="agent" class="font-weight-bold mt-1">{{agent}}</span>
                        <span *ngIf="!agent" class="font-italic mt-1" runat="server" Lang_Section="Contact_List" Lang_Key="Unassigned">Unassigned</span>
                    </div>
                    <div style="margin: 8px;" *ngIf="data?.CurrentStateName != null"  class='d-inline-flex pl-2 pr-2'>
                        <div class="flex_half_half"><span>{{data?.CurrentStateName}}</span></div>
                        <div class="flex_half_half"><span>Total Duration</span></div>
                    </div>
                    <div style="margin: 8px;" *ngIf="data?.CurrentStateName != null" class='d-inline-flex pl-2 pr-2'>
                        <div class="flex_half_half"><span style="padding: 8px; background-color: #DDD; border-radius: 5px;">{{data?.StateTimeDisplay}}</span></div>
                        <div class="flex_half_half"><span style="padding: 8px; background-color: #DDD; border-radius: 5px;">{{data?.TotalTimeDisplay}}</span></div>
                    </div>
                </div>
                <div style="min-height: 300px; max-height: 550px;">
                    <ag-grid-angular *ngIf="gridOptions != null"
                        class="ag-theme-balham flex-fill"
                        [gridOptions]="gridOptions"
                        style="height:100%; width:100%; max-height: 250px; overflow-y: auto;">
                    </ag-grid-angular>
                    <app-module-error *ngIf="noData" [noData]="true"></app-module-error>
                </div>
            </div>
        </div>
</div>
